import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { eraseKycIdentity } from '../../../fetchers';

export const useEraseKycIdentityMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ workflowId }: { workflowId: string }) => eraseKycIdentity({ workflowId }),
    onSuccess: result => {
      void queryClient.invalidateQueries();
      toast.success(
        result
          ? `Verification records deleted for ${result.subject}: ${result.runtimes} case(s), ${result.registryRows} dedup record(s), ${result.vectors} face vector(s).`
          : 'Verification records deleted.',
      );
      navigate('/en/case-management/entities');
    },
    onError: (error: Error) => {
      toast.error(`Failed to delete verification records: ${error?.message ?? 'Unknown error'}`);
    },
  });
};
